import { gql } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import link from 'shared/domains/apollo/link';
import { localeConfig } from 'shared/domains/languages/config';
const accountCompanyIdQuery = gql `
  query accountCompanyId {
    account @client {
      companyId: company_id
    }
  }
`;
function getTenantURL(context) {
    var _a;
    const { cache, withCompany } = context;
    if (withCompany !== null && withCompany !== void 0 ? withCompany : true) {
        const data = cache.readQuery({ query: accountCompanyIdQuery });
        if ((_a = data.account) === null || _a === void 0 ? void 0 : _a.companyId) {
            return `${process.env.API_ENDPOINT_GRAPHQL}/${data.account.companyId}`;
        }
    }
    return process.env.API_ENDPOINT_GRAPHQL;
}
const contextLink = setContext((request, context) => {
    const uri = getTenantURL(context);
    const headers = {};
    const { code } = localeConfig.getActiveLocale();
    headers['Accept-Language'] = code;
    return { uri, headers };
});
const httpLink = contextLink.concat(link);
export default httpLink;
